// textFieldStyles.js
export const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      height: 50, // Slightly increased height
      borderRadius: '10px', // Rounded corners
      '& fieldset': {
        borderWidth: 2, // Border width
      },
      '&:hover fieldset': {
        borderColor: 'primary.dark', // Border color on hover
      },
      '&.Mui-focused fieldset': {
        // Border color when focused
      },
    },
    // Adjusting padding to fit the increased height
    '& .MuiInputBase-input': {
      padding: '10px 12px', // Increased padding for better appearance
      fontFamily: 'Jost, sans-serif', // Apply Jost font
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(14px, 12px) scale(1)', // Adjusted label position if necessary
      fontFamily: 'Jost, sans-serif', // Apply Jost font
    },
  };
  